module.exports = __webpack_public_path__ + "static/media/pokestore.c4620d47.png";